import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule, NgForm } from '@angular/forms';
import { FirstLoginRequest, FirstLoginResponse } from '../../interfaces/first-login.interface';
import { FirstLoginService } from '../../services/first-login/first-login.service';
import { ErrorAlertComponent } from "../shared/error-alert/error-alert.component";
import { LoadingService } from '../../services/general/loading.service';
import { ConfirmationModalComponent } from '../shared/confirmation-modal/confirmation-modal.component';
import { LogTackingService } from '../../services/logs/log-tacking.service'
import { LogsTrackingRequest, LogsTrackingResponse } from '../../interfaces/logs_tracking.interface.';
import { PageHeaderComponent } from '../shared/page-header/page-header.component';



@Component({
  selector: 'app-first-login',
  standalone: true,
  imports: [CommonModule, FormsModule, ErrorAlertComponent, ReactiveFormsModule, ConfirmationModalComponent, PageHeaderComponent],
  templateUrl: './first-login.component.html',
  styleUrl: './first-login.component.css'
})
export class FirstLoginComponent {

  token: string = '';
  firstLoginRequest: FirstLoginRequest = {
    nit: '',
    email: '',
    accounts: ''
  };
  firstLoginResponse: FirstLoginResponse = {
    link: ''
  }
  errorMessage: string = '';
  showAlertError: boolean = false;
  isModalVisible: boolean = false
  firtLoginUrltext : string = ''
  log_info: LogsTrackingRequest = {
    email: localStorage.getItem('userName') ?? '',
    action: 'Obtener url first login',
    details: '',
    ip_address: localStorage.getItem('ip') ?? ''
  }

  constructor( 
    private _loadingService : LoadingService,
    private _logsService: LogTackingService,
    private _firstLoginService: FirstLoginService
  ){

  }

  ngOnInit(): void {
    this.token = localStorage.getItem('authToken') || '';
  }

  onSubmit(form: NgForm): void {
    this._loadingService.setLoading(true)
    this._firstLoginService.getUrlFirstLogin(this.token, this.firstLoginRequest).subscribe(
      (response: FirstLoginResponse) => {
        this.firstLoginResponse = response
        this.firtLoginUrltext = `La url es ${response.link}` 
        this.isModalVisible = true
        this.log_info.details = `Success: Usuario obtuvo url first login para el nit ${this.firstLoginRequest.nit}`
        this.createTrackingLog()
        this._loadingService.setLoading(false)
      },
      (error) => {
        if(error.error.error) this.errorMessage = error.error.error
        this.log_info.details = `Error: ${this.errorMessage}`
        this.showErrorComponent(form)
      }
    )
  }
  showErrorComponent(form: NgForm) {
    this._loadingService.setLoading(false);
    this.createTrackingLog()
    this.showAlertError = true
    setTimeout(() => {
      this.showAlertError = false;
      this.cancel(form)
    }, 6000);
  }

  cancel(form: NgForm) {
    form.resetForm();
  }

  onConfirm(form: NgForm) {
    
    this.isModalVisible = false;
    
  }

  onCancel() {
    this.isModalVisible = false;
  }

  createTrackingLog() {
    this._logsService.generateTrackingLog(this.log_info).subscribe({
      next: (response: LogsTrackingResponse) => { },
      error: (error) => {
        console.log(error);
      }
    });
  }

}
